<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Employee Relation</h4>
        <button type="button" #closebtn class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="relationform" (ngSubmit)="saveRelation()">
            <div class="form-body">
                <div class="row mb-3">
                    <div class="col-lg-7">
                        <label>Relation Name</label>
                        <div class="input-group">
                            <input class="form-control" formControlName="relation_name">
                        </div>
                        <!-- <span *ngIf="relation_name && relation_name.invalid" class="errormessage">Please Enter valid name</span> -->
                    </div>
                    <div class="col-lg-5">
                         <label>Phone</label>
                            <div class="input-group">
                            <input name="phone" class="form-control" formControlName="relation_phone">
                         </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-6">
                        <label>Relation Type</label>
                        <div class="input-group">
                            <select class="form-control" formControlName="relation_type" >
                                <option *ngFor="let item of relationTypes" value="{{item.id}}">{{item.lookup_name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-6">
                        <label>Relation Address</label>
                        <textarea class="form-control" formControlName="relation_address" cols="3"></textarea>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-6 ">
                        <label>Start Date</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="relation_start_date" ngbDatepicker #startDate="ngbDatepicker" 
                            placeholder="dd-mm-yyyy"  (dateSelect)="updateStartDate($event)"/>
                            <button class="btn btn-primary bx bx-calendar" (click)="startDate.toggle()" type="button"></button>
                        </div>
                        <!-- <span *ngIf="relation_start_date && relation_start_date.invalid" class="errormessage">Please enter valid Start Date</span> -->
                        </div>
                    <div class="col-lg-6">
                        <label>End Date</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="relation_end_date" ngbDatepicker #endDate="ngbDatepicker" 
                            placeholder="dd-mm-yyyy" (dateSelect)="updateEndDate($event)"/>
                            <button class="btn btn-primary bx bx-calendar" (click)="endDate.toggle()" type="button"></button>
                        </div>
                        <!-- <span *ngIf="relation_end_date && relation_end_date.invalid" class="errormessage">Please enter valid End Date</span> -->
                    </div>
                </div>
                <div class="row">
                     <div class="input-group">
                        <button [disabled]="relationform.invalid" type="submit" class="btn btn-primary">Save</button>
                    </div>
                    <span [ngClass]="errorclass" >{{errormessage}}</span>
                </div>
            </div>
        </form>
    </div>
</ng-template>